import { TriggerResponse } from './triggerTypes'
import { TriggerEndpoints } from './triggerEndpoints'

import request from 'core/config/request'
import { Trigger } from 'modules/trigger/types'

export class TriggerService {
  static getAllTriggers = async (transmissionCode: string) => {
    const { data } = await request.get<TriggerResponse>(TriggerEndpoints.getAllTriggers(transmissionCode), {
      headers: {
        Authorization: ''
      }
    })

    return data
  }

  static getTrigger = async (transmissionCode: string, triggerId: string) => {
    const { data } = await request.get<Trigger>(
      TriggerEndpoints.getTrigger(transmissionCode, triggerId),
      {
        headers: {
          Authorization: ''
        }
      }
    )

    return data
  }
}
